/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import theme from '../../../../../../assets/styles/theme/theme';
import useIsScreenSmallerThan from '../../../../../../hooks/useIsScreenSmallerThan';
import { BarGraph } from '@gerdau/hefesto-mais-web/BarGraph';
import { Column } from '@gerdau/hefesto-mais-web/_shared/graph/graph.types';

interface IChartBarsProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  chartData: any;
  isEmpty: boolean;
  columns: Column[];
}

const ChartBars: React.FC<IChartBarsProps> = ({
  chartData,
  isEmpty,
  columns
}) => {
  const isScreenSmallerThanTablet = useIsScreenSmallerThan(
    Number(theme.breakpoints.tablet.replace('px', ''))
  );

  return (
    <BarGraph
      barDataKey="date"
      dataSource={chartData}
      columns={columns}
      stacked
      layout={isScreenSmallerThanTablet ? 'vertical' : 'horizontal'}
      barGap={1}
      barCategoryGap={10}
      legendAlign="left"
      YAxisWidth={40}
      showLegend={!isEmpty}
    />
  );
};

export default ChartBars;
